import { render, staticRenderFns } from "./FormControlPagesUrlSlug.vue?vue&type=template&id=70c8e7e0"
import script from "./FormControlPagesUrlSlug.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPagesUrlSlug.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports